module.exports = __webpack_public_path__ + "static/media/2.fd614a8d.png";